import React, { useContext } from "react";
import {
    PortalSideNav,
    PortalSideNavButton,
    PortalSideNavHeader,
    PortalSideNavIcon,
    PortalSideNavList,
    PortalSideNavText
} from "src/components";
import { SIDEBAR_DATA } from "../constants";
import { EmailCampaignsContext } from "../EmailCampaignsContext";

export default function EmailCampaignsSidebar() {
    const { currentSidebar, setCurrentSidebar, setSelectedEmailsToDelete, deleteIsLoading } = useContext(EmailCampaignsContext);

    const onSidebarClick = (id) => {
        if (deleteIsLoading) {
            return;
        }
        setCurrentSidebar(id);
        setSelectedEmailsToDelete([]);
    };

    return (
        <PortalSideNav>
            <PortalSideNavHeader
                kicker="Campaigns"
                title="Email"
                description="Move between campaign lists, audiences, and settings."
            />
            <PortalSideNavList>
                {SIDEBAR_DATA.map(heading => (
                    <PortalSideNavButton
                        key={heading.id}
                        type="button"
                        $active={currentSidebar === heading.id}
                        disabled={deleteIsLoading}
                        onClick={() => onSidebarClick(heading.id)}
                    >
                        <PortalSideNavIcon $active={currentSidebar === heading.id}>
                            <img src={heading.icon} alt="" />
                        </PortalSideNavIcon>
                        <PortalSideNavText>{heading.title}</PortalSideNavText>
                    </PortalSideNavButton>
                ))}
            </PortalSideNavList>
        </PortalSideNav>
    );
}
